(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.qyntraaGarmentFilterReady) return;
  window.qyntraaGarmentFilterReady = true;

  const storageKey = 'qyntraa-garment-filter';
  const choices = new Set(['hoodies', 't-shirts']);
  let activeChoice = 't-shirts';

  try {
    const savedChoice = window.localStorage.getItem(storageKey);
    if (choices.has(savedChoice)) activeChoice = savedChoice;
  } catch (error) {}

  const applyChoice = () => {
    const toggles = document.querySelectorAll('[data-qyntraa-garment-toggle]');
    toggles.forEach((toggle) => {
      toggle.querySelectorAll('[data-qyntraa-garment-choice]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.qyntraaGarmentChoice === activeChoice));
      });
    });

    const cards = [...document.querySelectorAll('product-card[data-qyntraa-garment]')];
    const grids = new Set();
    cards.forEach((card) => {
      const item = card.closest('li') || card;
      const matches = card.dataset.qyntraaGarment === activeChoice;
      item.hidden = !matches;
      const grid = item.closest('ul.product-grid');
      if (grid) grids.add(grid);
    });

    grids.forEach((grid) => {
      let emptyMessage = grid.querySelector('[data-qyntraa-empty-message]');
      const hasMatch = [...grid.querySelectorAll('product-card[data-qyntraa-garment]')]
        .some((card) => card.dataset.qyntraaGarment === activeChoice);
      if (!emptyMessage && !hasMatch) {
        emptyMessage = document.createElement('li');
        emptyMessage.className = 'qyntraa-product-filter-empty';
        emptyMessage.dataset.qyntraaEmptyMessage = '';
        emptyMessage.setAttribute('role', 'status');
        grid.append(emptyMessage);
      }
      if (emptyMessage) {
        const toggle = document.querySelector('[data-qyntraa-garment-toggle]');
        const emptyText = activeChoice === 'hoodies'
          ? toggle?.dataset.noProductsHoodies
          : toggle?.dataset.noProductsTshirts;
        emptyMessage.textContent = emptyText || '';
        emptyMessage.hidden = hasMatch;
      }
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-qyntraa-garment-choice]');
    if (!button) return;
    const nextChoice = button.dataset.qyntraaGarmentChoice;
    if (!choices.has(nextChoice)) return;
    activeChoice = nextChoice;
    try {
      window.localStorage.setItem(storageKey, activeChoice);
    } catch (error) {}
    applyChoice();
  });

  window.addEventListener('storage', (event) => {
    if (event.key && event.key !== storageKey) return;
    if (choices.has(event.newValue)) activeChoice = event.newValue;
    applyChoice();
  });

  const startObserver = () => {
    applyChoice();
    if (document.body) {
      new MutationObserver(() => window.requestAnimationFrame(applyChoice))
        .observe(document.body, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
